import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import PrintPreview from "../PrintPreview";
import PdfStore from "../../../stores/PdfStore";
import "../Print.css";

const Barcode = require("react-barcode");
// const doctitle = ['ใบเคลม','ใบขับขี่','ตารางกรมธรรม์','พรบ.','สำเนาทะเบียนรถ','บัตรเจ้าของรถ','เลขครัชซี','สัญญาประณีประนอมยอมความ']
class PrintSSTBigJobDoc extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      data: { car: { car_registration_no: "" }, insurer: { claim_no: "" } },
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    //this._notificationSystem = this.refs.notificationSystem;
    this.loadWorkCoverFileDoc();
  }

  loadWorkCoverFileDoc() {
    let { workNo } = this.props;
    let that = this;
    this.setState({ loading: true });
    PdfStore.loadWorkBigJobDoc(workNo, function (result) {
      let data = result.data;
      //data['related_detail'] = Object.assign(that.state.data.related_detail,data.related_detail)
      data = Object.assign(that.state.data, data);
      that.setState({ data: data });
    });
  }

  onCopyPaperChange() {}

  renderLogoUrl(logoUrl) {
    let imgUrl = "";
    if (process.env.NODE_ENV == "development") {
      imgUrl = "https://demo2.bigfix.co/korat/pdf/" + logoUrl;
    } else {
      imgUrl = "../" + logoUrl;
    }
    return <img src={imgUrl} />;
  }

  renderJobNo() {
    let workNo = this.props.workNo;
    let jobNo = "";
    // let regex = /[+-]?\d+(?:\.\d+)?/g;

    let list = workNo.split("/");
    if (list.length >= 2) {
      let nextList = list[0].split(".");
      if (nextList.length >= 2) {
        jobNo = nextList[1] * 1;
      } else {
        jobNo = decodeURIComponent(list[0]).replace(/^\D+/g, "") * 1;
      }
    } else {
      jobNo = decodeURIComponent(workNo).replace(/^\D+/g, "") * 1;
    }

    return <span className="text-red">({jobNo})</span>;
  }

  renderProvince(){
    let { car, insurer } = this.state.data;
    return <span className="text-red">{car.short_province}</span>;
  }

  renderComponentPage() {
    //let {doclist} = this.state
    let { data } = this.state;
    let { car, insurer } = this.state.data;
    console.log("data", data);
    console.log("data.pdf", data.pdf_config);

    return (
      <div
        style={{ fontSize: "100px", fontWeight: "bold", height: "100%" }}
        className="text-center"
      >
        <div
          style={{
            position: "absolute",
            top: "calc(30% - 280px)",
            left: "0",
            width: "100%",
          }}
        >
          <Row>
            <Col md={12} className="text-center">
              {insurer.claim_no}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-center">
              {car.car_registration_no} {data.pdf_config && data.pdf_config.show_province?this.renderProvince():this.renderJobNo()}
            </Col>
          </Row>
          <Row style={{ margin: 40 }}>
            <Col md={12}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "28px",
                  fontWeight: "bold",
                  height: "100%",
                  wordWrap: "break-word",
                }}
              >
                {car.brand + " " + car.model}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-center">
              {data.pdf_config &&
                (data.pdf_config.show_work_no ? this.props.workNo : "")}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="text-center">
                <Barcode
                  value={this.props.workNo}
                  width={1}
                  height={30}
                  textAlign={"center"}
                  fontSize={12}
                />
              </div>
            </Col>
          </Row>
        </div>
        <div
          style={{
            position: "absolute",
            top: "calc(50% + 70px)",
            left: "0",
            width: "100%",
          }}
        >
          <Row>
            <Col md={12} className="text-center">
              {insurer.claim_no}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-center">              
              {car.car_registration_no} {data.pdf_config && data.pdf_config.show_province?this.renderProvince():this.renderJobNo()}
            </Col>
          </Row>
          <Row style={{ margin: 40 }}>
            <Col md={12}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "28px",
                  fontWeight: "bold",
                  height: "100%",
                  wordWrap: "break-word",
                }}
              >
                {car.brand + " " + car.model}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="text-center">
              {data.pdf_config &&
                (data.pdf_config.show_work_no ? this.props.workNo : "")}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="text-center">
                <Barcode
                  value={this.props.workNo}
                  width={1}
                  height={30}
                  textAlign={"center"}
                  fontSize={12}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  render() {
    let { loading } = this.state;
    return (
      <PrintPreview
        loading={loading}
        leftBarTitle={"ใบปะหน้ารถ " + this.props.workNo}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    );
  }
}

PrintSSTBigJobDoc.defaultProps = {
  title: "",
  mode: "1",
};
export default PrintSSTBigJobDoc;



// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTBigJobDoc.js